export const modalKeys = {
    MODAL_STATUS: 'modalStatus',
}
